<style src="./styles.scss" lang="scss"></style>
<template>
  <div class="container">
    <br />
    <spinner v-if="showSpinner" />
    <header class="row history-header">
      <div class="col-md-3">
        <label for="">Selecione a conta</label>
        <select class="form-control" v-model="selectedAccount">
          <option
            v-for="(account, index) in accounts"
            :key="index"
            :value="account"
          >
            {{ account.name }}
          </option>
        </select>
      </div>
      <div class="col-md-3">
        <label for="">Selecione o periodo</label>
        <select class="form-control" v-model="selectedPeriod">
          <option
            v-for="(account, index) in period"
            :key="index"
            :value="account.value"
          >
            {{ account.label }}
          </option>
        </select>
      </div>
      <div class="col-md-3">
        <div class="space-25"></div>
        <button
          type="button"
          class="btn btn-sm btn-primary"
          @click="listHistory"
        >
          <i class="fa fa-search"></i>
          Buscar
        </button>
      </div>
      <div class="col-md-3" v-if="movementHistory.account">
        <span class="label label-primary pull-right amount-content">
          Saldo: R$
          {{ totalToCurrencyBR(movementHistory.account.actualBalance) }}
        </span>
      </div>
    </header>
    <main>
      <HistoryItem
        :history="movementHistory.history"
        :account="movementHistory.account ? movementHistory.account._id : ''"
      />
    </main>
  </div>
</template>
<script>
import { subDays } from 'date-fns';
import HistoryItem from './components/history-item/HistoryItem';
import Spinner from '@/components/Spinner';
import { toast } from '@/plugins/toast';

export default {
  components: {
    HistoryItem,
    Spinner,
  },
  data() {
    return {
      showSpinner: false,
      period: [
        {
          label: '15 dias',
          value: 15,
        },
        {
          label: '30 dias',
          value: 30,
        },
        {
          label: '45 dias',
          value: 45,
        },
      ],
      selectedPeriod: 15,
      accounts: [],
      selectedAccount: {},
      movementHistory: {},
    };
  },

  mounted() {
    this.listAccounts();
  },
  methods: {
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    async listAccounts() {
      try {
        this.showSpinner = true;
        const accounts = await this.$store.dispatch(
          'FINANCIAL-ACCOUNT/ListAll',
        );
        const defaultAccount = accounts.find(
          (acc) => acc.defaultAccount === true,
        );
        if (!this.selectedAccount._id) this.selectedAccount = defaultAccount;
        else {
          this.selectedAccount = accounts.find(
            (acc) => String(acc._id) === String(this.selectedAccount._id),
          );
        }
        this.accounts = accounts;
      } catch (error) {
        toast.error('Não foi possível listar as contas');
      } finally {
        this.showSpinner = false;
      }
    },
    async listHistory() {
      try {
        this.showSpinner = true;
        const actualTime = new Date();
        const range = {
          to: actualTime,
          from: subDays(actualTime, this.selectedPeriod),
        };
        const movementHistory = await this.$store.dispatch(
          'FINANCIAL-ACCOUNT/ListHistory',
          {
            range,
            financialAccountId: this.selectedAccount._id,
          },
        );
        this.movementHistory = movementHistory;
      } catch (error) {
        toast.error('Não foi possível carregar o histórico');
      } finally {
        this.showSpinner = false;
      }
    },
  },
};
</script>